import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Booking from "@/pages/Booking";
import BookingConfirmation from "@/pages/BookingConfirmation";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import AdminBookings from "@/pages/admin/Bookings";
import AdminServices from "@/pages/admin/AdminServices";
import AdminInvoices from "@/pages/admin/Invoices";
import AdminCustomers from "@/pages/admin/Customers";
import AdminSite from "@/pages/admin/Site";
import AdminAvailability from "@/pages/admin/Availability";
import AdminContracts from "@/pages/admin/Contracts";
import AdminGalleries from "@/pages/admin/Galleries";
import AdminGalleryDetail from "@/pages/admin/GalleryDetail";
import AdminGalleryClientDetail from "@/pages/admin/GalleryClientDetail";
import SignContract from "@/pages/SignContract";
import PublicGallery from "@/pages/Gallery";
import PublicReview from "@/pages/Review";
import AdminReviews from "@/pages/admin/Reviews";
import AdminWaitlist from "@/pages/admin/Waitlist";
import AdminInquiries from "@/pages/admin/Inquiries";
import AdminStudioInvites from "@/pages/admin/StudioInvites";
import LumetierOnboard from "@/pages/lumetier/Onboard";
import StudioPublic from "@/pages/StudioPublic";
import LumetierPreview from "@/pages/LumetierPreview";
import LumetierIndustries from "@/pages/lumetier/Industries";
import LumetierLanding from "@/pages/lumetier/Landing";

// Hoisted so the Toaster doesn't get a fresh object on every App render.
const TOASTER_OPTIONS = { className: "font-sans" };

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" toastOptions={TOASTER_OPTIONS } />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/booking/confirmation/:reference" element={<BookingConfirmation />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/lumetier-preview" element={<LumetierPreview />} />
            <Route path="/lumetier" element={<LumetierLanding />} />
            <Route path="/lumetier/industries" element={<LumetierIndustries />} />
            <Route path="/lumetier/onboard" element={<LumetierOnboard />} />
            {/* Per-tenant public booking site (Phase 3) */}
            <Route path="/s/:slug" element={<StudioPublic />} />
            {/* Legacy redirects so any old "atelier" links/bookmarks still resolve */}
            <Route path="/atelier-preview" element={<LumetierPreview />} />
            <Route path="/atelier" element={<LumetierLanding />} />
            <Route path="/atelier/industries" element={<LumetierIndustries />} />
            <Route path="/contract/sign/:token" element={<SignContract />} />
            <Route path="/gallery/:slug" element={<PublicGallery />} />
            <Route path="/review/:token" element={<PublicReview />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="invoices" element={<AdminInvoices />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="availability" element={<AdminAvailability />} />
              <Route path="contracts" element={<AdminContracts />} />
              <Route path="galleries" element={<AdminGalleries />} />
              <Route path="galleries/clients/:clientId" element={<AdminGalleryClientDetail />} />
              <Route path="galleries/:id" element={<AdminGalleryDetail />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="waitlist" element={<AdminWaitlist />} />
              <Route path="studio-invites" element={<AdminStudioInvites />} />
              <Route path="site" element={<AdminSite />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
